import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { ScholarshipDescription } from '../../../classes/scholarship-description';

@Component({
    selector: 'app-selected-scholarships-modal',
    templateUrl: './selected-scholarships-modal.component.html',
    styleUrls: ['./selected-scholarships-modal.component.scss'],
    imports: [
        MatDialogModule,
        MatButtonModule
    ]
})
export class SelectedScholarshipsModalComponent {
    protected readonly dialogRef = inject(MatDialogRef<SelectedScholarshipsModalComponent>);
    protected readonly data: { scholarshipDescriptions: ScholarshipDescription[] } = inject(MAT_DIALOG_DATA);

    closeDialog() {
        this.dialogRef.close(null);
    }
}
